export const STORE_TOKEN = 'auth.token'
